import moment from 'moment';

export const getStatementPeriod = (date: string = '') => {
  return moment.utc(date).format('MMM, YYYY');
};
